import { render, staticRenderFns } from "./v-order-canister-remove-popup.vue?vue&type=template&id=14dfb1d0&scoped=true"
import script from "./v-order-canister-remove-popup.vue?vue&type=script&lang=js"
export * from "./v-order-canister-remove-popup.vue?vue&type=script&lang=js"
import style0 from "./v-order-canister-remove-popup.vue?vue&type=style&index=0&id=14dfb1d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14dfb1d0",
  null
  
)

export default component.exports